import styled from "styled-components";

export const Wrapper = styled.div`
    .profile-avatar-wrapper {
        position: relative;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        border: 4px solid #f8f9fa;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        background: #f5f8fa;
    }

    .profile-avatar-wrapper.is-editing {
        cursor: pointer;
    }

    .profile-avatar-wrapper img {
        display: block;
    }

    .avatar-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.25s ease;
    }

    .profile-avatar-wrapper.is-editing:hover .avatar-overlay {
        opacity: 1;
    }

    .ant-upload-wrapper {
        text-align: center;
    }

    .ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select,
    .ant-upload-wrapper.ant-upload-picture-circle-wrapper .ant-upload.ant-upload-select {
        width: 72px !important;
        height: 72px !important;
    }

    .ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select:not(.ant-upload-disabled):hover,
    .ant-upload-wrapper.ant-upload-picture-circle-wrapper .ant-upload.ant-upload-select:not(.ant-upload-disabled):hover {
        border-color: rgb(255, 0, 0);
    }
`;
